import React from 'react';
import { LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import { TERM_TO_RATE, RFC_2822_MONTHS } from './AmortizationCalculator.utils.js';
import amortjsonblock from './amortblock.js';
import AmortizationCalculator from './AmortizationCalculator.js';
import { useMortgageRatesTable } from '../MortgageRatesTable/MortgageRatesTable.js';

var AmortizationBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    //Api call for fetching the current mortgage rate
    var _useMortgageRatesTabl = useMortgageRatesTable({
        partnerId: 'RD-QCBWMVN',
        columns: 'rate',
        refinance: false,
        queries: [{
          program: 'Fixed30Year'
        }],
        rateCompare: 'lastWeek',
        loanToValueBucket: 'Normal',
        creditScoreBucket: 'VeryHigh',
        rateLocation: 'US'
      }),
      rates = _useMortgageRatesTabl.rates;
    //updated the default interest rate with current rate
    rates === null || rates === void 0 || rates.map(function (formattedRate) {
      amortjsonblock.attributes.rate.default = formattedRate.rate;
    });
    var _attrs$amount = attrs.amount,
      amount = _attrs$amount === void 0 ? 200000 : _attrs$amount,
      _attrs$term = attrs.term,
      term = _attrs$term === void 0 ? LOAN_PROGRAMS.fixed30Year : _attrs$term,
      _attrs$rate = attrs.rate,
      rate = _attrs$rate === void 0 ? TERM_TO_RATE.Fixed30Year.rate : _attrs$rate,
      _attrs$startMonth = attrs.startMonth,
      startMonth = _attrs$startMonth === void 0 ? RFC_2822_MONTHS[new Date().getMonth()] : _attrs$startMonth,
      _attrs$startYear = attrs.startYear,
      startYear = _attrs$startYear === void 0 ? new Date().getFullYear() : _attrs$startYear;
    var defaultValues = {
      amount: amount,
      term: term,
      rate: rate,
      startMonth: startMonth,
      startYear: startYear
    };
    return /*#__PURE__*/React.createElement(AmortizationCalculator, {
      defaultValues: defaultValues
    });
  },
  metadata: amortjsonblock
};

export { AmortizationBlock as default };
